
import { authorize_onboarding } from "../helper/authorize-token";
import superagent from 'superagent';

const GOVERNOR_SET_DATA = "GOVERNOR_SET_DATA";

const loadGovernorData = (token, onboarding_token) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/governor/load")
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        return resolve(result.body.data);
      })
  })
};

const updateGovernorData = data => {
  return dispatch => {
    dispatch({
      type: GOVERNOR_SET_DATA,
      payload: data,
    })
  }
}

const governorReducer = (state = {}, action) => {

  switch(action.type) {
    case GOVERNOR_SET_DATA:
      return Object.assign(state, action.payload);
    default:
      return state;
  }
};

export { governorReducer, loadGovernorData, updateGovernorData };
